/* eslint-disable sort-keys */
import textStyles from "../constants/textStyles";


const defaultVariant = {
    field: {
       
        "mb": "0",
        "borderRadius": "5",
        "borderWidth": "1px", // todo define in terms of theme
        "borderStyle": "solid",
        "borderColor": "secondary.100",
        "fontWeight": "600",
        "transition":
            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        "&[type=\"password\"]": {
            fontSize: "1.9rem" // todo: define in terms of theme
        },
        "_placeholder": { opacity: "0.3" },
        // todo define in terms of theme
        "_hover": { borderColor: "secondary.200" },
        "_focus": { borderColor: "primary.400", _hover: { borderColor: "primary.400" }, borderWidth: "2px", borderStyle: "solid" },
        "_active": { borderColor: "primary.400", _hover: { borderColor: "primary.400" }, borderWidth: "2px", borderStyle: "solid" },
        "_disabled": { borderColor: "secondary.100", bgColor: "secondary.100", opacity: "0.7", _hover: { borderColor: "secondary.100" } },

    },
};

export default {
    Input: {
        baseStyle: {
            field: {
                boxShadow: "none",
                _active: { boxShadow: "none" },
                _focus: { boxShadow: "none" },
                _placeholder: { color: "gray.400" },
            },
        },
        sizes: {
            md: {
                height: "12",
                px: "4",
                ...textStyles.p1,
            },
            sm: {
                px: "2",
                ...textStyles.p2,
            }
        },
        variants: {
            default: {
                ...defaultVariant,
            },
            error: {
                ...defaultVariant,
                borderColor: "accentRed.400",
            }
        },
        defaultProps: {
            variant: "default",
        },
    },
};
